import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SheetsSummaryAccordion from '@hkm/components/Attendant/SheetSummary/body/SheetSummaryAccordion/SheetsSummaryAccordion';
import { SheetSummaryValue } from '@hkm/components/Attendant/SheetSummary/models/SheetSummaryValue';
import BadgeWithCount from '@hkm/components/shared/BadgeWithCount/BadgeWithCount';
import classNames from 'classnames';

import { AcFlex } from '@ac/mobile-components/dist/components/flex';
import { AcText } from '@ac/mobile-components/dist/components/text';
import {
  Color,
  Icon,
  TextSize,
  TextWeight
} from '@ac/mobile-components/dist/enums';
import { Styleable } from '@ac/mobile-components/dist/interfaces/componentProps';

export interface SpecialNeedsProps extends Styleable {
  needs: SheetSummaryValue[];
}

export const SpecialNeeds: React.FC<SpecialNeedsProps> = (
  props: SpecialNeedsProps
) => {
  const { t } = useTranslation();

  const total = useMemo(() => {
    return props.needs.reduce((sum, preference) => sum + preference.count, 0);
  }, [props.needs]);

  const renderSubtitle = useMemo(
    () => (
      <AcText size={TextSize.H1} weight={TextWeight.Semibold}>
        {total}
      </AcText>
    ),
    [total]
  );

  const renderContent = useMemo(
    () => (
      <AcFlex wrapped={true}>
        {props.needs.map((specialNeed, index) => (
          <BadgeWithCount
            key={index}
            backgroundColor={specialNeed.color || Color.Alert}
            badgeText={specialNeed.description}
            count={specialNeed.count}
            className={classNames(
              index !== props.needs.length - 1 && 'ac-spacing-right-sm',
              'ac-spacing-bottom-sm'
            )}
            testSelector="special-need-badge"
          />
        ))}
      </AcFlex>
    ),
    [props.needs]
  );

  return (
    <SheetsSummaryAccordion
      icon={Icon.Disability}
      title={t('ATTENDANT_ASSIGNMENTS.SHEET_SUMMARY.SPECIAL_NEEDS.TITLE')}
      renderSubtitle={renderSubtitle}
      renderContent={renderContent}
      expandDisabled={total === 0}
      className={props.className}
    />
  );
};

export default memo(SpecialNeeds);



// WEBPACK FOOTER //
// ./src/components/Attendant/SheetSummary/body/SpecialNeeds/SpecialNeeds.tsx